var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile_container",on:{"click":function($event){return _vm.$emit('click', _vm.tool)}}},[_c('div',{staticClass:"tile"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.tool.image}})]),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.tool.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }